export enum ImagingType {
  ULTRASOUNDS = "Ultrasounds",
  X_RAYS = "X-Rays",
  CT_SCANS = "CT Scans",
  MRI = "MRI",
  NUCLEAR_MEDICINE = "Nuclear Medicine",
  DEXA = "DEXA",
  RETINA_EYE_EXAM = "Retina Eye Exam",
  ECHO = "Echo",
  CARDIAC_TESTS = "Cardiac Tests",
  SPIROMETRY = "Spirometry",
  COLONOSCOPY = "Colonoscopy",
  SIGMOIDOSCOPY = "Sigmoidoscopy",
  MAMMOGRAM = "Mammogram",
  PET = "PET",
}
